import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LogIn, Plus } from "lucide-react";
import "./SumAssuredStyle.scss";
import { useTranslation } from "react-i18next";
import AddBeneficiary from "../Beneficiary/Beneficiary";
import { updateLeadsLife } from "../../Redux/LogsRedux/Life/LifeLeadsRedux";
import { useDispatch } from "react-redux";

const SumAssuredPage = ({ planDetails }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  // const { planDetails } = location.state;
  const { t,i18n } = useTranslation();
  const [sumAssuredOptions, setSumAssuredOptions] = useState([]);
  const [showError, setShowError] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [updatedData, setUpdatedData] = useState();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (planDetails?.termPlan?.prices) {
      setSumAssuredOptions(planDetails?.termPlan?.prices);
    }
  }, [planDetails]);

  const handleSelect = (option, idx) => {
    setSelectedOption(option);
    setSelectedIndex(idx);
    const updatedData = {
      ...planDetails,
      selectedPlan: option,
    };
    setUpdatedData(updatedData);
    setIsSelected(true);
    setShowError(false);
  };

  const handleConfirm = () => {
    if (!isSelected) {
      setShowError(true);
      return;
    }
    const payload = {
      transId: localStorage.getItem("LIFE_LEAD_ID"),
      selectedSumAssured: selectedOption,
    };
    dispatch(updateLeadsLife(payload)).then((response) => {
      if (response.success) {
        const updatedData = {
          ...planDetails,
          selectedLimit: selectedOption,
        };
        setUpdatedData(updatedData);
        setShowConfirm(true);
      }
    });
  };

  return (
    <>
      <div className="row mt-2">
        <div className="col-md-12 p-3">
          {/* <h3 className="title pt-2 mb-2">{t(planDetails?.coverPlan)}</h3> */}
          <h5 className="title subHeader p-0 fw-bold mb-2">
            {t("Choose Your Sum Assured")}
          </h5>
        </div>
      </div>
      <div className="sum-cards-wrapper">
        <div className="row g-4">
            {sumAssuredOptions.map((option, index) => (
              <div className="col-lg-4 col-md-6 col-12" key={index}>
                <div
                  className={`sum-card ${selectedIndex === index ? "active" : ""}`}
                  onClick={() => handleSelect(option, index)}
                >
                  <div className="sum-card-content">
                    <div className="sum-left">
                      <div className="info-section">
                        <div className="plan-benefits">{t("Premium")}</div>
                        <div className="sum-amount">
                          <span className="amount1">{option.premium}.000</span>
                          <span className="currency">OMR</span>
                        </div>
                        <div className="sum-text1">{t("Sum Assured")}</div>
                        <div className="sum-amount ">
                          <span className="amount1">{option.sum_assured}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="planSelect">
                    <button
                      type="button"
                      className={`round ${selectedIndex === index ? "active" : ""}`}
                    >
                      <i
                        className={`bi bi-check-lg plan-select-icon ${selectedIndex === index ? "active-icon" : ""}`}
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      {!isSelected && showError && (
        <label className="text-danger d-flex justify-content-center m-0 p-0">
          Please select the plan
        </label>
      )}

      <div className="row justify-content-center mt-4 pb-4">
        <div className="col-lg-4 col-md-4"></div>
        <div className="col-lg-4 col-md-4"></div>
        <div
          className={`col-lg-4 col-md-4 ${i18n.language === "ar" ? "text-start" : "text-end"} mb-2`}
        >
          <button
            type="button"
            onClick={handleConfirm}
            className="btn btn-primary"
          >
            {t("Next")}
          </button>
        </div>
        {showConfirm && updatedData && (
          <>
            <div
              className="modal fade show"
              style={{ display: "block" }}
              role="dialog"
              aria-modal="true"
            >
              <div
                className="modal-dialog modal-dialog-scrollable modal-dialog-centered"
                 style={{ maxWidth: "900px", width: "95%" }}
              >
                <div className="modal-content">
                  {/* <div className="modal-header border-0">
                  <h5 className="modal-title">{t("Plan Details")}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setShowConfirm(false)}
                  ></button>
                </div> */}
                  <div className="modal-body">
                    <AddBeneficiary
                      setShowConfirm={setShowConfirm}
                      planDetails={updatedData}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-backdrop fade show"></div>
          </>
        )}
      </div>
    </>
  );
};

export default SumAssuredPage;
